import React from "react";
import UserColumn from "src/components/DefaultColumnsList/User";
import List from "src/components/List";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { checkSituationOccurrence } from "../../interface";
import BadgeSituationOcurrences from "../BadgeOccurrences";
import { IListOccurrences } from "./interface";
import { OverflowSpan } from "./styles";

const ListOccurrences: React.FC<IListOccurrences> = ({
	data,
	options,
	filter,
	layout,
	refModalRegisterHistory,
	openModalAttachments,
	openModalHistory,
	openModalImmediateActions
}) => {
	const { translate, currentLanguage } = useTranslation();

	const colData = (row : any) => (
		<OverflowSpan>{formatDate(row.ocb001Data, currentLanguage)}</OverflowSpan>
	);

	const colCurrentStage = (row : any) => {
		let color: "blue" | "purple" | "red" | "green" | "grey" | "black";

		if(row.late && (row.ocb001Status === checkSituationOccurrence.OPENED || row.ocb001Status === checkSituationOccurrence.NOT_STARTED)){
			color = "red";
		}else{
			switch(row.ocb001Status){
			case checkSituationOccurrence.NOT_STARTED:
				color = "blue";
				break;
			case checkSituationOccurrence.OPENED:
				color = "purple";
				break;
			case checkSituationOccurrence.FINISHED:
				color = "green";
				break;
			case checkSituationOccurrence.CANCELED:
				color = "grey";
				break;
			case checkSituationOccurrence.DISAPPROVED:
				color = "black";
				break;
			default: 
				color = "green";
				break;
			}
		}

		let text = "";
		switch(row.ocb001Status){
		case checkSituationOccurrence.FINISHED:
			text = "Finalizada";
			break;
		case checkSituationOccurrence.CANCELED:
			text = "Cancelada";
			break;
		case checkSituationOccurrence.DISAPPROVED:
			text = "Reprovada";
			break;
		default: 
			text = row.oca003Descricao;
			break;
		}

		return (
			<>
				<div style={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", background: `var(--${color})`}}/>
				<OverflowSpan>{translate(text)}</OverflowSpan>
			</>
		);
	};
	
	const colOccurrence = (row: any) => (
		<OverflowSpan title={row.fullTitle}><b>{row.fullTitle}</b></OverflowSpan>
	);

	const colRequirement = (row : any) => (
		<OverflowSpan>{row.oca001Descricao}</OverflowSpan>
	);

	const colSource = (row: any) => (
		<OverflowSpan>{row.oca002Descricao}</OverflowSpan>
	);

	const colCategory = (row: any) => (
		<OverflowSpan>{row.oca004Descricao}</OverflowSpan>
	);

	const colResponsable = (row: any) => (
		<>
			<UserColumn 
				name={row.ocb001Efa005Nome2}
				image={row.ocb001Efa005Imagem2}	
			/>
		</>
	);

	const colSituation = (row: any) => (
		<BadgeSituationOcurrences 
			ocurrence={row}
			refModalRegisterHistory={refModalRegisterHistory}
			openModalAttachments={openModalAttachments}
			openModalHistory={openModalHistory}
			openModalImmediateActions={openModalImmediateActions}
		/>	
	);

	return (
		<>
			<List 
				data={data}
				filter={filter}
				layout={layout ?? undefined}
				columns={[
					{
						idColumn: "fullTitle",
						nameColumn: translate("Título"),
						md: 3,
						sm: 3,
						xs: 12,
						justify: "left",
						cellRenderer: colOccurrence
					},
					{
						idColumn: "ocb001Data",
						nameColumn: translate("Data"),
						md: 1,
						sm: 1,
						xs: 12,
						justify: "left",
						cellRenderer: colData 
					},
					{
						idColumn: "oca004Descricao",
						nameColumn: translate("Etapa atual"),	
						md: 1,
						sm: 1,
						xs: 12,
						justify: "left",
						cellRenderer: colCurrentStage
					},
					{
						idColumn: "oca001Descricao",
						nameColumn: translate("Requisito"),
						md: 2,
						sm: 2,
						xs: 12,
						justify: "left",	
						cellRenderer: colRequirement
					},
					{
						idColumn: "ocb001Oca002Descricao",
						nameColumn: translate("Origem"),
						sm: 1,
						xs: 12,
						justify: "left",
						hidden: ["sm", "md"],
						truncate: true,
						cellRenderer: colSource
					},
					{
						idColumn: "ocb001Oca004Descricao",
						nameColumn: translate("Categoria"),
						md: 2,
						sm: 1,
						xs: 12,
						hidden: ["sm"],
						justify: "left",
						cellRenderer: colCategory
					},
					{
						idColumn: "eftba005",
						nameColumn: translate("Responsável etapa"),
						md: 1,
						sm: 1,
						xs: 12,
						justify: "left",
						cellRenderer: colResponsable
					},
					{
						idColumn: "eftba005",
						nameColumn: "",
						md: 1,
						sm: 2,
						xs: 12,
						justify: "left",
						cellRenderer: colSituation
					},
					{
						idColumn: "options",
						nameColumn: " ",
						styleInline: "position: absolute; right: -2px; bottom: 0; width: fit-content !important;",
						hideHeader: true,
						cellRenderer: options
					}
				]}
				styleInline="li.list-component-child { border-top-left-radius: 0; border-bottom-left-radius: 0; }"
				showHeader
			/>
		</> 
	);

};

export default ListOccurrences;
